// extracted by mini-css-extract-plugin
export default {"container":"SizeOptionDetails_container__dLIZL","sizeName":"SizeOptionDetails_sizeName__Y4W4-","sizeDescription":"SizeOptionDetails_sizeDescription__C6wYW"};